import React from 'react';
import { l10n } from '../../../i18n/Localization';
import { CharacterViewPrimaryPart, CharacterViewDateTimePart } from '../CharacterViewPart';

const Sc2CharacterView = (props) => {
    const { sc2Character, showingToOwner } = props;

    return (
        <div>
            <CharacterViewPrimaryPart className="mb-3" character={sc2Character} showingToOwner={showingToOwner} />
            {
                (sc2Character.avatarUrl !== undefined && sc2Character.avatarUrl !== null) ? (
                    <div>
                        <img src={sc2Character.avatarUrl} width="128" alt={l10n.sc2CharacterView.avatar}></img>
                    </div>
                ) : null
            }
            <div>{l10n.sc2CharacterView.profileUrl}: {sc2Character.profileUrl}</div>
            <div>{l10n.sc2CharacterView.name}: {sc2Character.name}</div>
            {
                showingToOwner ? (
                    (sc2Character.isVerified && sc2Character.name !== sc2Character.identificationName) ? (
                        <div className="text-success">{l10n.sc2CharacterView.changeNameToIdentificationName}</div>
                    ) : null
                ) : (
                    (sc2Character.name !== sc2Character.identificationName) ? (
                        <div className="text-warning">{l10n.sc2CharacterView.nameNotSameAsIdentificationName}</div>
                    ) : null
                )
            }
            <div>{l10n.sc2CharacterView.region}: {sc2Character.region}</div>
            <div>{l10n.sc2CharacterView.realm}: {sc2Character.realm}</div>
            <CharacterViewDateTimePart className="mt-3" character={sc2Character} />
        </div>
    );
};

export default Sc2CharacterView;
